var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.59616 3.78265C10.6439 1.89667 13.3563 1.89668 14.404 3.78265L21.6519 16.8288C22.6702 18.6617 21.3448 20.9143 19.2479 20.9143H4.75225C2.65542 20.9143 1.33 18.6617 2.34831 16.8288L9.59616 3.78265ZM10.8461 8.69941C10.7979 8.02946 11.3285 7.45945 12.0001 7.45945C12.6718 7.45945 13.2024 8.02946 13.1542 8.69941L12.7873 13.8076C12.7576 14.2205 12.414 14.5402 12.0001 14.5402C11.5862 14.5402 11.2427 14.2205 11.213 13.8076L10.8461 8.69941ZM13.0004 17.0489C13.0004 17.6015 12.5525 18.0495 11.9999 18.0495C11.4472 18.0495 10.9993 17.6015 10.9993 17.0489C10.9993 16.4963 11.4472 16.0483 11.9999 16.0483C12.5525 16.0483 13.0004 16.4963 13.0004 17.0489Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.a88817079c6688ad9a6aeb822910c94a.svg";
export { ForwardRef as ReactComponent };